import React, { PureComponent } from 'react';
import styled from 'styled-components';
import GlobalStyle from 'stylecomponents/globalstyle';
import Navbar from 'components/commons/Navbar';
import { Route } from "react-router-dom";
import CupoyRouter from "components/commons/router/CupoyRouter";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import actionCreators from 'actions/creators';
import BonusProductListItemView from 'components/bonusproducts/commons/BonusProductListItemView';
import NewProductsSideBarView from 'components/newproducts/commons/NewProductsSideBarView';
import productUtil, { PRODUCT_COVER_SIZE } from 'util/productUtil';

const Container = GlobalStyle.SubContainer.extend`
  display: grid;
  grid-template-columns: 1fr 244px;
  grid-template-rows: auto auto;
  grid-gap: ${GlobalStyle.ViewSpace}px;
  margin-top: ${props => props.marginTop? GlobalStyle.ViewSpace:0}px;
`

const Main = styled.div`
`

const FlexContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`

const StatusContainer = GlobalStyle.BasicBlock.extend`
    margin-bottom: ${GlobalStyle.ViewSpace}px;
`;

const navInfo = {
  title: "發財商城",
  list: [
    {title: '免費發財商城', stateName: 'BONUSPRODUCTS'},
    {title: '發財金使用說明', stateName: 'BONUSPRODUCTS_USE'},
    {title: '發財金紀錄', stateName: 'BONUSPRODUCTS_RECORD'},
    {title: '發財金兌換', stateName: 'BONUSPRODUCTS_CONVERT'},
  ],
}

class BonusProductsView extends PureComponent {
  
  constructor(props) {
    super(props);

    this.state = {
      MemberBonusDepositViewComponent: null,
      MemberBonusLogsViewComponent: null,
      UseViewComponent: null,
      isEmpty: false,
      bonusremain: props.memberinfo?.bonusremain || 0,
    };
  }

  componentDidMount() {

    window.scrollTo({ top: 0 });

    // check後台發財商城開放狀態
    this.checkWebState();

    const { bonusProductIds } = this.props;

    if(Array.isArray(bonusProductIds) && bonusProductIds.length === 0){
      this.fetchBonusProducts();
    }

    this.lazyLoadComponent();
  }

  checkWebState = () => {
    this.props.webActions.checkWebState();
  }

  fetchBonusProducts = () => {

    const { isloading, error } = this.props;

    if(isloading || error) return;

    this.props.cardActions.listBonusProducts().then(() => {

      const { bonusProductIds = [] } = this.props;

      if(bonusProductIds.length === 0){
        this.setState({
          isEmpty: true,
        });
      }
    });
  }

  buyBonus = (productid, event) => {

    event.stopPropagation();

    const {
      cardProductMap,
    } = this.props;

    const product = cardProductMap[productid];
    const { jsdproductid } = product;

    this.props.webActions.openBuyBonusPdtDialog(
      productid,
      jsdproductid
    );
  }

  lazyLoadComponent = () => {
    import("components/member/MemberBonusLogsView").then(MemberBonusLogsModule => {
        this.setState({ MemberBonusLogsViewComponent: MemberBonusLogsModule.default });
    }).catch(err => console.log(err));
    import('components/bonusproducts/UseView').then(UseViewModule => {
      this.setState({ UseViewComponent: UseViewModule.default });
    }).catch(err => console.log(err));
    import('components/member/MemberBonusDepositView').then(MemberBonusDepositModule => {
        this.setState({ MemberBonusDepositViewComponent: MemberBonusDepositModule.default });
    }).catch(err => console.log(err));
  }

  routeToContent = id => {
    this.props.webActions.cupoyStateGo(CupoyRouter.STATES.BONUS_PRODUCT, { id });
  }

  renderLazyComponent = () => {
    const {
      MemberBonusLogsViewComponent,
      UseViewComponent,
      MemberBonusDepositViewComponent,
    } = this.state;

    return (
      <React.Fragment>
        {MemberBonusDepositViewComponent && <Route path={CupoyRouter.PATHS.BONUSPRODUCTS_CONVERT} component={MemberBonusDepositViewComponent} exact /> }
        {MemberBonusLogsViewComponent && <Route path={CupoyRouter.PATHS.BONUSPRODUCTS_RECORD} component={MemberBonusLogsViewComponent} exact /> }
        {UseViewComponent && <Route path={CupoyRouter.PATHS.BONUSPRODUCTS_USE} component={UseViewComponent} exact /> }
      </React.Fragment>
    )
  }

  renderBonusProducts = () => {

    const {
      bonusProductIds = [],
      cardProductMap,
      BONUSMALL,
    } = this.props;

    if(!BONUSMALL) return (
      <StatusContainer>
        <GlobalStyle.ErrorContainer>
          <GlobalStyle.ErrorContainerTitle>
            發財商城暫停使用中
          </GlobalStyle.ErrorContainerTitle>
        </GlobalStyle.ErrorContainer>
      </StatusContainer>
    );

    return (
      <React.Fragment>
        <FlexContainer>
          {
            bonusProductIds.map((productid, index) => {

              const product = cardProductMap[productid];

              const {
                thumbimg,
                productname = '',
                hottag,
                updatetime,
              } = product;

              const imageSrc = productUtil.getProductCover(PRODUCT_COVER_SIZE.LARGE, productid, thumbimg, updatetime);

              return (
                <BonusProductListItemView
                  key={productid}
                  id={productid}
                  imageSrc={imageSrc}
                  isHot={hottag}
                  name={productname.trim()}
                  needMarginRight={(index + 1) % 4 !== 0}
                  routeToContent={this.routeToContent}
                  buyBonus={this.buyBonus}
                />
              );
            })
          }
        </FlexContainer>
        {this.props.isloading ?
          <GlobalStyle.LoadingContainer>
            <GlobalStyle.Spin />
          </GlobalStyle.LoadingContainer>
          :
          null
        }
        {this.props.error ?
          <StatusContainer>
            <GlobalStyle.ErrorContainer>
              <GlobalStyle.ErrorContainerTitle>
                發生錯誤
              </GlobalStyle.ErrorContainerTitle>
              <GlobalStyle.ErrorContainerDesription>
                無法取得商品列表，請重新整理後再嘗試。
              </GlobalStyle.ErrorContainerDesription>
            </GlobalStyle.ErrorContainer>
          </StatusContainer>
          :
          null
        }
        {this.state.isEmpty ?
          <StatusContainer>
            <GlobalStyle.ErrorContainer>
              <GlobalStyle.ErrorContainerTitle>
                查無資料
              </GlobalStyle.ErrorContainerTitle>
              <GlobalStyle.ErrorContainerDesription>
                目前此類查無商品
              </GlobalStyle.ErrorContainerDesription>
            </GlobalStyle.ErrorContainer>
          </StatusContainer>
          :
          null
        }
      </React.Fragment>
    )
  }

  render() {

    const { memberinfo, haslogin } = this.props;
    const { bonusremain = 0 } = memberinfo;

    return (
      <Container>
        <Main>
          <Navbar
            marginBottom
            list={navInfo.list}
            title={navInfo.title}
            block
            money={bonusremain}
            haslogin={haslogin}
          />
          {CupoyRouter.isActive(CupoyRouter.STATES.BONUSPRODUCTS)?
            this.renderBonusProducts() :
            this.renderLazyComponent()}
        </Main>
        <NewProductsSideBarView />
      </Container>
    )
  }

}

/*--------------------------
    Reducer Props
--------------------------*/
const mapStateToProps = function(state) {
  return {
    haslogin: state.member.haslogin,
    cardProductMap: state.card.cardProductMap,
    bonusProductIds: state.card.bonusProductIds,
    memberinfo: state.member.memberinfo,
    BONUSMALL: state.web.BONUSMALL,
    isloading: state.card.isloading,
    error: state.card.error,
  };
};

/*--------------------------
  Reducer Action
--------------------------*/
const mapActionToProps = function(dispatch) {
  return {
    webActions: bindActionCreators(actionCreators.webActionCreators, dispatch),
    cardActions: bindActionCreators(actionCreators.cardActionCreators, dispatch),
    cardOrderActions: bindActionCreators(actionCreators.cardOrderActionCreators, dispatch),
  };
};

/*--------------------------
  export
--------------------------*/
export default connect(mapStateToProps, mapActionToProps, null, {
  forwardRef: true
})(BonusProductsView);
